module.exports = {
      id: "vikatan-play-logo-red-usage",
      viewBox: "0 0 536.066 789.439",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#vikatan-play-logo-red",
      toString: function () {
        return this.url;
      }
    }